import { apiService } from '../../utils/api';

/** Follow both numeric and DRF URL pagination without sending credentials to a next URL. */
export async function fetchPickerPages<T>(
  url: string,
  params: Record<string, unknown>,
  signal: AbortSignal
): Promise<T[]> {
  const rows: T[] = [];
  const visited = new Set<string>();
  let page: string | number = 1;
  while (!signal.aborted) {
    if (visited.has(String(page))) throw new Error('Neplatné stránkování seznamu.');
    visited.add(String(page));
    const { data } = await apiService.get(url, { params: { ...params, page }, signal });
    const results = Array.isArray(data) ? data : data?.results;
    if (!Array.isArray(results)) throw new Error('Neplatný formát seznamu.');
    rows.push(...results);
    if (Array.isArray(data) || !data.next) return rows;
    const next = String(data.next);
    const nextPage = /^\d+$/.test(next)
      ? next
      : new URL(next, 'https://local.invalid').searchParams.get('page');
    if (!nextPage) throw new Error('Neplatné stránkování seznamu.');
    page = nextPage;
  }
  return [];
}
